import { useEffect } from 'react';

export function useOnOutsideClickAction(closestElSelector: string | string[], fn: () => void) {
    useEffect(() => {
        const closeOnOutsideClick = (event: Event) => {
            const target = event.target as HTMLElement;

            if (
                !(Array.isArray(closestElSelector) ? closestElSelector : [closestElSelector]).some((selector) =>
                    target.closest(selector),
                )
            ) {
                fn();
            }
        };

        document.documentElement.addEventListener('click', closeOnOutsideClick);

        return () => document.documentElement.removeEventListener('click', closeOnOutsideClick);
    }, [closestElSelector, fn]);
}
